<template>
  <div data-test="forgot-password-form">
    <div>
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        @submit.prevent.native="submit">
        <el-form-item prop="password" :label="$t('resetPasswordForm.passwordLabel')">
          <el-input
            data-test="pass-form-input__password"
            v-model="form.password"
            type="password"
            :placeholder="$t('resetPasswordForm.passwordLabel')">
          </el-input>
        </el-form-item>
        <el-form-item
          prop="confirmation" :label="$t('resetPasswordForm.passwordConfirmationLabel')">
          <el-input
            data-test="pass-form-input__confirmation"
            v-model="form.confirmation"
            type="password"
            :placeholder="$t('resetPasswordForm.passwordConfirmationLabel')">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="update-pwd__button"
            v-loading="loading"
            data-test="submit-button"
            type="success"
            @click="submit">
            {{ saveButtonText }}
          </el-button>

          <el-button
            class="cancel__button"
            data-test="cancel-button"
            v-if="!hideCancel"
            @click="handleCancel">
            {{ cancelButtonText }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import validatePasswordMixin from '@/mixins/validatePassword';

export default {
  mixins: [validatePasswordMixin],
  props: {
    saveButtonText: { type: String },
    cancelButtonText: { type: String, default: 'Annuler' },
    hideCancel: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      showForgotPassword: false,
      rules: {
        password: [
          {
            required: true,
            message: this.$t('resetPasswordForm.wrongPasswordFormatMessage'),
            trigger: ['blur', 'change'],
            validator: this.$passwordValidator,
          },
        ],
        confirmation: [
          {
            required: true,
            message: this.$t('resetPasswordForm.wrongConfirmationMessage'),
            trigger: ['blur', 'change'],
            validator: this.$passwordConfirmValidator,
          },
        ],
      },
      form: {
        password: '',
        confirmation: '',
      },
    };
  },
  methods: {
    handleCancel() {
      this.$emit('canceled');
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) { return; }
        this.$emit('submited', this.form);
      });
    },
  },
};
</script>
<style lang="stylus" scoped>

.update-pwd__button, .cancel__button {
  width: 100%;
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
}
// iPad Portrait
@media only screen and (min-width: 48rem) {
}
//iPad Landscape + desktop
@media only screen and (min-width: 64rem) {
  .update-pwd__button, .cancel__button {
    width: auto;
  }
  .cancel__button {
    margin-left: 10px;
  }
}
//Desktop petit + hd desktop
@media only screen and (min-width: 80rem) {
}
</style>
